module.exports = __webpack_public_path__ + "static/agut-gray-b11bc5a753c50ba4ac62746e95f7e659.png";